import { useMemo } from 'react';
import useSubscription from '../subscription';
import { IS_MICRO_GENRE_PAYWALL_ENABLED } from './constants';

const useFeature = () => {
  const { isSubscriptionActive } = useSubscription();

  const isMicroGenrePaywallEnabled = useMemo(
    () => !isSubscriptionActive && IS_MICRO_GENRE_PAYWALL_ENABLED,
    [isSubscriptionActive]
  );

  return {
    isMicroGenrePaywallEnabled,
  };
};

export default useFeature;
